import { render, staticRenderFns } from "./TOTPAuth.vue?vue&type=template&id=1c46b35a"
import script from "./TOTPAuth.vue?vue&type=script&lang=js"
export * from "./TOTPAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports